/**
 * Angular adapter for @axon-rto/fusus-web-telemetry.
 *
 * The npm package is framework-agnostic (plain TypeScript). This adapter
 * re-exports everything and overrides FsTelemetryService with an
 * @Injectable({ providedIn: 'root' }) subclass so Angular's DI can
 * resolve it automatically — including in TestBed.
 *
 * All registry code imports from '@axon-rto/fusus-web-telemetry', which
 * tsconfig.base.json maps here instead of node_modules.
 */
import { Injectable } from '@angular/core';
import { FsTelemetryService as _Base } from '@axon-rto/fusus-web-telemetry-core';

@Injectable({ providedIn: 'root' })
export class FsTelemetryService extends _Base {}

export * from '@axon-rto/fusus-web-telemetry-core';
export * from './telemetry-attributes';
